<app-banner-app [retroSelected]="true" [Parametros]="this.parametro" [PaginaAnterior]="'InfoImmueble'"
    [IdentLead]="this.leadId"></app-banner-app>
<br><br>

<!-- Timelines -->
<div class="visibilidadDiv">
    <div class="container" style="width: 700px;">
        <div class="row">
            <div class="col">
                <br><br><br><br>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="text-align: center;">
                        <div class="step" data-target="#test-l-1">
                            <div>
                                <div>
                                    <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Arriendo</span>
                            </div>

                        </div>

                        <div class="line" style="height: 2px; margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-2">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Planes</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos propietario</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-4">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Inmueble</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-5">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum"
                                    style="background-color: #2D6DF6;">5</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos inquilino</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>

<!-- Progress Bar -->
<div class="container contenedorProgressBar">
    <br><br>
    <div class="row">
        <div class="col">
            <strong>
                <p class="progressBarActivo">Datos del inquilino</p>
            </strong>
        </div>
    </div>
    <ngb-progressbar class="mb-3" type="primary" [value]="100" height=".5rem">
    </ngb-progressbar>
</div>

<br>

<div class="container">
    <div class="row">
        <div class="col">
            <div class="textoArriba">
                <div class="aliniacionTexto">
                    <p class="textoInquilino">Completa los datos del<br>
                        inquilino
                    </p>
                </div>
                <div class="aliniacionImagen">
                    <img class="styleImage img-responsive" src="./assets/img/Apartamento.png" />
                    <br><br><br>
                </div>
            </div>
            <div class="textoAbajo">
                <div class="aliniacionTextoMobile">
                    <p class="texto1">Completa los datos del inquilino
                    </p>
                </div>
            </div>
        </div>

        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <main class="form-signin w-100 m-auto">
                <form [formGroup]="formulario">
                    <label for="primerNombre" style="color: #3F3F41;" class="tipoLetra">*Nombre y apellido</label>

                    <input type="text" #primerNombre required class="form-control tipoLetra estiloPrincipal"
                        formControlName="primerNombre" id="primerNombre" placeholder="Escribe tu nombre"
                        style="color: #000; height: 48px;"
                        [ngClass]="{ valPrimerNombre2: valPrimerNombre2, valPrimerNombre: valPrimerNombre }"
                        (focusout)="validacionPrimerNombre()">
                    <small *ngIf="nombrePrimerNoValido" class="text-danger tipoLetra">Ingresa tu nombre y
                        apellido</small>
                    <br>

                    <label for="numCelular" style="color: #3F3F41;" class="tipoLetra">*Número de celular</label>

                    <input type="number" class="form-control tipoLetra estiloPrincipal" #numCelular
                        formControlName="numCelular" id="numCelular" placeholder="Ej: 3004263078" required
                        [ngClass]="{ valCelular2: valCelular2, valCelular: valCelular }"
                        (focusout)="validacionCelular()" [ngModel]="" (wheel)="$event.preventDefault()">
                    <small *ngIf="this.valCelular" class="text-danger tipoLetra">
                        Asegúrate de ingresar un número válido de 10 dígitos</small>

                    <small *ngIf="cedularNoValido" class="text-danger tipoLetra">
                        Asegúrate de ingresar un número válido de 10 dígitos</small>
                    <br>

                    <label for="correo" style="color: #3F3F41;" class="tipoLetra">*Correo electrónico</label>

                    <input type="text" class="form-control tipoLetra estiloPrincipal" #correo formControlName="correo"
                        id="correo" placeholder="usuario@correo.com" required
                        [ngClass]="{ valEmail2: valEmail2, valEmail: valEmail }" (focusout)="validacionEmail()"
                        [ngModel]="">
                    <small *ngIf="correoNoValido" class="text-danger tipoLetra">Escribe un correo valido</small>
                    <p class="camposObligatorios">*Los campos son obligatorios</p>
                    <br>

                    <div class="estiloBoton">
                        <button [disabled]="formularioNoValido" class="btn btn-primary w-100 py-2 botonContinuar"
                            (click)="Validaciones()">
                            Continuar
                        </button>
                    </div>
                    <br><br>

                </form>
            </main>
        </div>
    </div>
</div>

<app-footer-app />